/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetActiveOffersRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {GetActiveOffersResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const getActiveOffers = (request: GetActiveOffersRequest, options?: CashRequestOptions) => post<GetActiveOffersRequest, GetActiveOffersResponse>("/2.0/cash/get-active-offers", request, {...options, rejectOnError: true })